import React, { useState } from 'react'
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import styles from "../../styles/styles";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { server } from "../../server";
import { toast } from "react-toastify";


const Login = () => {
    const navigate = useNavigate()
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("")
    const [visible, setVisible] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault();

        await axios
            .post(
                `${server}/user/login-user`,
                {
                    email,
                    password,
                },
                { withCredentials: true }
            ).then((res) => {
                toast.success("Login Sucess!")
                navigate("/")
                window.location.reload(true);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };

    return (
        <div className='min-h-screen'>
            <div className='container'>
                <div className='mt-8 wrap'>
                    <div className='auth-box'>
                        <h2 className="">
                            Sign In
                        </h2>
                        <form className='space-y-6' onSubmit={handleSubmit} >
                            {/* Email */}
                            <div>
                                <label htmlFor="email"
                                    className='block text-sm font-medium text-gray-700'
                                >
                                    Email address
                                </label>
                                <div className='mt-1'>
                                    <input type="email"
                                        name='email'
                                        autoComplete='email'
                                        required
                                        placeholder='Please enter valid email'
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className='appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm'
                                    />

                                </div>
                            </div>
                            {/* Password */}
                            <div>
                                <label htmlFor="password"
                                    className='block text-sm font-medium text-gray-700'
                                >
                                    password
                                </label>
                                <div className='mt-1 relative'>
                                    <input type={visible ? "text" : "password"}
                                        name='password'
                                        autoComplete='password'
                                        required
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        className='appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm'
                                    />
                                    {visible ? (
                                        <AiOutlineEye
                                            className="absolute right-2 top-2 cursor-pointer"
                                            size={25}
                                            onClick={() => setVisible(false)}
                                        />
                                    ) : (
                                        <AiOutlineEyeInvisible
                                            className="absolute right-3 top-3 cursor-pointer"
                                            size={25}
                                            onClick={() => setVisible(true)}
                                        />
                                    )}

                                </div>
                            </div>
                            {/* password end */}

                            <div className={`${styles.noramlFlex} justify-between`}>
                                <div className={`${styles.noramlFlex}`}>
                                    <input
                                        type="checkbox"
                                        name="remember-me"
                                        id="remember-me"
                                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                    />
                                    <label
                                        htmlFor="remember-me"
                                        className="ml-2 block text-sm text-gray-900"
                                    >
                                        Remember me
                                    </label>
                                </div>
                                <div className='text-sm'>
                                    <a
                                        href=".forgot-password"
                                        className="font-medium text-blue-600 hover:text-blue-500"
                                    >
                                        Forgot your password?
                                    </a>
                                </div>
                            </div>
                            <div>
                                <button
                                    type='submit'
                                    className=' className="btn primary-btn group relative w-full h-[50px] flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white"'
                                >
                                    Login Now
                                </button>
                            </div>

                            <div className={`${styles.noramlFlex} w-full cta`} >
                                <h4>Not have any account</h4>
                                <Link to="/sign-up" className="text-blue-600 pl-2">
                                    Sign Up
                                </Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login